const METAOBJECT_DETAIL_FIELDS_TUNE = `#graphql
  fragment MetaobjectDetailFieldsTune on Metaobject {
    id
    type
    fields {
      key
      value
      type
      reference {
        ...MediaImageFields
        ...VideoFields
        ... on Product {
          ...ProductFieldsTune
        }
      }
    }
  }
`;

const METAOBJECT_DETAIL_FIELDS = `#graphql
  fragment MetaobjectDetailFields on Metaobject {
    __typename
    id
    type
    fields {
      key
      value
      type
      reference {
        ...MediaImageFields
        ...VideoFields
        ... on Product {
          ...ProductCommonFields
        }
      }
    }
  }
`;

const METAOBJECT_DETAIL_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment MetaobjectDetailFieldsWellbeingexpress on Metaobject {
    id
    type
    fields {
      key
      value
      type
      reference {
        ...MediaImageFields
        ...VideoFields
        ... on Product {
          ...ProductFieldsWellbeingexpress
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference { ...MediaImageFields }
                references(first: 10) { edges { node { ...MediaImageFields } } }
              }
        }
      }
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductFieldsWellbeingexpress
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference { ...MediaImageFields }
                references(first: 10) { edges { node { ...MediaImageFields } } }
              }
            }
            ...MediaImageFields
          }
        }
      }
    }
  }
`;

/* 기존 metaObjectImageProductFragment */

const METAOBJECT_IMAGE_PRODUCT_FIELDS_TUNE = `#graphql
  fragment MetaobjectImageProductFieldsTune on Metaobject {
    __typename
    id
    fields {
      key
      value
      reference {
        ...MediaImageFields
        ...VideoFields
        ... on Product {
          ...ProductFieldsTune
        }
      }
      references(first: 12) {
        edges {
          node {
            ...MediaImageFields
            ... on Product {
              ...ProductFieldsTune
              tag: metafield(namespace: "info", key: "tag") { ...MetafieldFields }
              launches: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectKeyValueFields }
              }
              variants(first: 10) {
                edges {
                  node {
                    ...VariantBaseFields
                    product { handle }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const METAOBJECT_IMAGE_PRODUCT_FIELDS_YESEYESEE = `#graphql
  fragment MetaobjectImageProductFieldsYeseyesee on Metaobject {
    id
    fields {
      key
      value
      reference {
        ...MediaImageFields
        ...VideoFields
        ... on Product {
          ...ProductCommonFields
        }
      }
      references(first: 12) {
        edges {
          node {
            ...MediaImageFields
            ... on Product {
              ...ProductCommonFields
              tag: metafield(namespace: "info", key: "tag") { ...MetafieldFields }
              launches: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectKeyValueFields }
              }
              variants(first: 10) {
                edges {
                  node {
                    ...VariantBaseFields
                    product { handle }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const METAOBJECT_IMAGE_PRODUCT_FIELDS_THISISNEVERTHAT = `#graphql
  fragment MetaobjectImageProductFieldsThisisneverthat on Metaobject {
    id
    fields {
      key
      value
      reference {
        ...MediaImageFields
        ...VideoFields
        ... on Product {
          ...ProductCommonFields
        }
      }
      references(first: 12) {
        edges {
          node {
            ...MediaImageFields
            ... on Product {
              ...ProductCommonFields
              tag: metafield(namespace: "info", key: "tag") { ...MetafieldFields }
              launches: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectKeyValueFields }
              }
              variants(first: 10) {
                edges {
                  node {
                    ...VariantBaseFields
                    product { handle }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const METAOBJECT_IMAGE_PRODUCT_FIELDS_KHAKIS = `#graphql
  fragment MetaobjectImageProductFieldsKhakis on Metaobject {
    id
    fields {
      key
      value
      reference {
        ...MediaImageFields
        ...VideoFields
        ... on Product {
          ...ProductCommonFields
        }
      }
      references(first: 12) {
        edges {
          node {
            ...MediaImageFields
            ... on Product {
              ...ProductCommonFields
              tag: metafield(namespace: "info", key: "tag") { ...MetafieldFields }
              launches: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectKeyValueFields }
              }
              variants(first: 10) {
                edges {
                  node {
                    ...VariantBaseFields
                        ...VariantMetafieldsKhakis
                    product { handle }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const METAOBJECT_IMAGE_PRODUCT_FIELDS_SUNLOVE = `#graphql
  fragment MetaobjectImageProductFieldsSunlove on Metaobject {
    id
    fields {
      key
      value
      reference {
        ...MediaImageFields
        ...VideoFields
        ... on Product {
          ...ProductCommonFields
        }
      }
      references(first: 12) {
        edges {
          node {
            ...MediaImageFields
            ... on Product {
              ...ProductCommonFields
              tag: metafield(namespace: "info", key: "tag") { ...MetafieldFields }
              launches: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectKeyValueFields }
              }
              variants(first: 10) {
                edges {
                  node {
                    ...VariantBaseFields
                    product { handle }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const METAOBJECT_IMAGE_PRODUCT_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment MetaobjectImageProductFieldsWellbeingexpress on Metaobject {
    id
    fields {
      key
      value
      reference {
        ...MediaImageFields
        ...VideoFields
        ... on Product {
          ...ProductFieldsWellbeingexpress
        }
      }
      references(first: 12) {
        edges {
          node {
            ...MediaImageFields
            ... on Product {
              ...ProductFieldsWellbeingexpress
              tag: metafield(namespace: "info", key: "tag") { ...MetafieldFields }
              launches: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectKeyValueFields }
              }
              variants(first: 10) {
                edges {
                  node {
                    ...VariantBaseFields
                    product { handle }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/** 메타오브젝트 필드 기본 (key/value/type) */
const METAOBJECT_FIELD_FIELDS = `#graphql
  fragment MetaobjectFieldFields on MetaobjectField {
    value
    key
    type
  }
`;

/** 이 파일의 모든 fragment (registry 등록용) */
/* ------------------------------------------------------------------ *
 * tenui - 홈 레이아웃(home_layout)·공지(notice)·스토키스트(stockist) 메타오브젝트를 쓴다.
 *         배너 아이템이 MediaImage 와 Video 를 모두 참조한다.
 * ------------------------------------------------------------------ */

const METAOBJECT_DETAIL_FIELDS_TENUI = `#graphql
  fragment MetaobjectDetailFieldsTenui on Metaobject {
    __typename
    id
    type
    handle
    fields {
      key
      value
      type
      reference {
        __typename
        ...MediaImageFields
        ...VideoFields
        ... on Product {
          ...ProductCommonFields
        }
      }
      references(first: 100) {
        edges {
          node {
            __typename
            ...MediaImageFields
            ... on Product {
              ...ProductCommonFields
              cardTag: metafield(namespace: "info", key: "card_tag") { ...MetafieldFields }
            }
          }
        }
      }
    }
  }
`;

/**
 * tenui 홈은 home_layout > section_list > banner_items 로 메타오브젝트가 2단 중첩된다.
 * (hydrogen 의 HOME_LAYOUT_QUERY 구조를 그대로 옮긴 것)
 * 그래서 references 안에 `... on Metaobject` 한 단계를 더 둔다.
 */
const METAOBJECT_IMAGE_PRODUCT_FIELDS_TENUI = `#graphql
  fragment MetaobjectImageProductFieldsTenui on Metaobject {
    __typename
    id
    handle
    type
    fields {
      key
      value
      reference {
        __typename
        ...MediaImageFields
        ...VideoFields
      }
      references(first: 20) {
        edges {
          node {
            __typename
            ...MediaImageFields
            ...VideoFields
            ... on Metaobject {
              id
              handle
              type
              fields {
                key
                value
                reference {
                  __typename
                  ...MediaImageFields
                  ...VideoFields
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const METAOBJECT_FRAGMENTS = [
  METAOBJECT_DETAIL_FIELDS_TUNE,
  METAOBJECT_DETAIL_FIELDS,
  METAOBJECT_DETAIL_FIELDS_WELLBEINGEXPRESS,
  METAOBJECT_IMAGE_PRODUCT_FIELDS_TUNE,
  METAOBJECT_IMAGE_PRODUCT_FIELDS_YESEYESEE,
  METAOBJECT_IMAGE_PRODUCT_FIELDS_THISISNEVERTHAT,
  METAOBJECT_IMAGE_PRODUCT_FIELDS_KHAKIS,
  METAOBJECT_IMAGE_PRODUCT_FIELDS_SUNLOVE,
  METAOBJECT_IMAGE_PRODUCT_FIELDS_WELLBEINGEXPRESS,
  METAOBJECT_DETAIL_FIELDS_TENUI,
  METAOBJECT_IMAGE_PRODUCT_FIELDS_TENUI,
  METAOBJECT_FIELD_FIELDS,
];
